import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useCompany } from '../context/CompanyContext';

const NotFound = () => {
  const { companyName } = useCompany();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #002A54 0%, #004080 50%, #0d3d6b 100%)',
        p: 3,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decoración de fondo */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.03)',
          filter: 'blur(40px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '10%',
          right: '5%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.02)',
          filter: 'blur(60px)',
        }}
      />

      <Paper
        elevation={24}
        sx={{
          maxWidth: 600,
          width: '100%',
          p: { xs: 4, sm: 6 },
          borderRadius: 4,
          textAlign: 'center',
          position: 'relative',
          zIndex: 1,
          boxShadow: '0 25px 80px rgba(0, 42, 84, 0.3)',
        }}
      >
        {/* Icono grande */}
        <Box
          sx={{
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(0, 42, 84, 0.1) 0%, rgba(0, 42, 84, 0.05) 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
            position: 'relative',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: 800,
              fontSize: '4rem',
              color: 'primary.main',
              letterSpacing: '-0.05em',
            }}
          >
            404
          </Typography>
          <ErrorOutlineIcon
            sx={{
              position: 'absolute',
              top: -10,
              right: -10,
              fontSize: 40,
              color: 'error.main',
            }}
          />
        </Box>

        <Typography
          variant="h4"
          fontWeight={800}
          gutterBottom
          sx={{ color: 'text.primary' }}
        >
          Página no encontrada
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400, mx: 'auto' }}>
          Lo sentimos, la página que estás buscando no existe o ha sido movida.
          Puedes volver al inicio o explorar nuestro catálogo.
        </Typography>

        {/* Enlaces rápidos */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            sx={{
              px: 4,
              py: 1.5,
              fontWeight: 700,
              boxShadow: '0 4px 16px rgba(0, 42, 84, 0.3)',
            }}
          >
            Volver al Inicio
          </Button>
          <Button
            component={Link}
            to="/catalogo"
            variant="outlined"
            size="large"
            startIcon={<SearchIcon />}
            sx={{ px: 4, py: 1.5, fontWeight: 700 }}
          >
            Explorar Catálogo
          </Button>
        </Box>

        {/* Suggestions */}
        <Box sx={{ mt: 4, pt: 4, borderTop: '1px solid', borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            ¿Buscabas algo específico?
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
            {['Insumos', 'Consultorio', 'Contacto'].map((item) => (
              <Button
                key={item}
                component={Link}
                to={item === 'Insumos' ? '/catalogo' : item === 'Consultorio' ? '/consultorio' : '/contacto'}
                size="small"
                sx={{ color: 'primary.main', fontWeight: 600 }}
              >
                {item}
              </Button>
            ))}
          </Box>
        </Box>

        {/* Logo */}
        <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <LocalHospitalIcon color="primary" />
          {companyName ? (
            <Typography variant="h6" fontWeight={700} color="primary.main">
              {companyName}
            </Typography>
          ) : null}
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFound;
